// dev gateway for Hitchcock
let wsApiGateway =
  "wss://67fgqhypl7.execute-api.us-east-1.amazonaws.com/production/";
let loginURL = "https://api.shorttok.com/ap-api-test/login";
let feedApiUrl = "https://api.shorttok.com/ap-api-test/video-story-feed";
let userEventsURL = "https://api.shorttok.com/ap-api-test/hc-user-events";
let storylinesAPI = "https://api.shorttok.com/ap-api-test/storylines-for-query";
let mediaAPI = "https://api.shorttok.com/ap-api-test/media";
let localUrl = "http://localhost:8080/";
let appName = "hitchcock-dev";
let liveStreamURL =
  "https://jf8etdrnm2.execute-api.us-east-1.amazonaws.com/api/stream/all";
// "https://lci5iimgyj.execute-api.us-east-1.amazonaws.com/api/stream/all";

if (process.env.REACT_APP_ENVIRONMENT === "production") {
  // these are all the same as the defaults for now to ensure no breakage
  wsApiGateway =
    "wss://67fgqhypl7.execute-api.us-east-1.amazonaws.com/production/";
  loginURL = "https://api.shorttok.com/ap-api/login";
  feedApiUrl = "https://api.shorttok.com/ap-api/video-story-feed";
  userEventsURL = "https://api.shorttok.com/ap-api/hc-user-events";
  storylinesAPI = "https://api.shorttok.com/ap-api-test/storylines-for-query";
  mediaAPI = "https://api.shorttok.com/ap-api-test/media";
  localUrl = "http://localhost:8080/";
  appName = "hitchcock-dev";
}

export {
  wsApiGateway,
  localUrl,
  loginURL,
  feedApiUrl,
  userEventsURL,
  storylinesAPI,
  mediaAPI,
  appName,
  liveStreamURL,
};
